import React from 'react';

interface IconProps {
    fill?: string;
    width?: number;
    height?: number;
    thickness?: number;
}

export const CrossIcon = ({
    width = 8,
    height = 8,
    fill = '#818998',
    thickness = 1,
}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 8 8"
        fill="none"
    >
        <path
            d="M1 1L7 7M7 1L1 7"
            stroke={fill}
            strokeWidth={thickness}
            strokeLinecap="round"
        />
    </svg>
);
